export const currentProjectTodoTemplates = (state, getters) => {
  return state.currentProjectTodoTemplates;
};
export const currentProjectActiveTodoTemplates = (state, getters) => {
  return state.currentProjectTodoTemplates.filter((t) => !t.archived);
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoTemplateGetters.js